import { Component } from '@angular/core';

@Component({
    selector   : 'glink-demo-sidebar',
    templateUrl: './demo-sidebar.component.html',
    styleUrls  : ['./demo-sidebar.component.scss']
})
export class GLinkDemoSidebarComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
